import React from "react";

import {Map, InfoWindow, Marker, GoogleApiWrapper} from 'google-maps-react';
import Geocode from "react-geocode";
import "./Coverage.scss";

import Footer from "./../../components/footer/Footer";
import { Link } from "react-router-dom";
var statesData = require('./states.json');

class Details extends React.Component {

    constructor(props) {
        super(props);
        this.state = { 
            area:  this.props.match.params.area_id
        };
    }

    componentDidMount() { 
    
    }

    render() {
        const { area } = this.state;
        const selectArea = statesData.find((item) => {
            return item.abbreviation.toLowerCase() === area
        });
    
        return <React.Fragment>
            <div className="title-section">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#f3f1fc" fill-opacity="1" d="M0,160L120,138.7C240,117,480,75,720,90.7C960,107,1200,181,1320,218.7L1440,256L1440,0L1320,0C1200,0,960,0,720,0C480,0,240,0,120,0L0,0Z"></path></svg>

                <div className="container">
                    <h1 className="page-title">
                        {selectArea.name} Answering Service
                    </h1>
                </div>

                
            </div>
            <div className="container">
                <div className="row">
                    <div className="service-details">
                        
                        <div className="content-wrap">
                            <h2 className="heading">
                                Virtual Enterprise Answering Services {selectArea.name} the best solution for you and your customers! Free Setup & Activation.
                            </h2>
                            <h4 className="sub-heading">
                            Virtual Enterprise Answering Service {selectArea.name} is a customer service and operator solution for your small businesses in Arkansas.
                            </h4>
                            <article>
                                <p>We will provide you with a local {selectArea.name} telephone number that you can either advertise or divert your existing number to. You do not need any additional equipment to start using our Answering Service and we can have you set up in minutes. Your virtual receptionist will answer calls in your company name and sound exactly like your own company receptionist.
                                </p>
                            </article>
                            <article>
                                 <p>We can then transfer the caller through to you on your mobile or landline. If you are unavailable we can take a message and send it to you by either email or text message depending on your call handling instructions.</p>
                            </article>
                            <article className="feature-article">
                                <ul className="feature-list l">
                                <li>E-commerce websites</li>
                                <li>Product / Services</li>
                                <li>Seminar Reservation</li>
                                <li>Event Planning Companies</li>
                                <li>Dentists</li>
                                <li>Funeral homes</li>
                                <li>Lawyers</li>
                                <li>Insurance Companies</li>
                                <li>HVAC / Plumbing companies</li>
                                <li>Any other companies/ services that requires calls to be answered </li>
                                 </ul>
                                 <ul className="feature-list r">
                                <li>Building Construction</li>
                                <li>Appointment scheduling</li>
                                <li>Help Desk support</li>
                                <li>Repossession companies</li>
                                <li>Towing companies</li>
                                <li>Dealer locator services</li>
                                <li>Property Management</li>
                                <li>IT Support Companies</li>
                                <li>Emergency response answering service</li>
                                <li>General contractors/Construction Companies</li>
                                 </ul>
                            </article>
                            <article>
                                <h3 className="to-upper">Did you Say Per Call Answering Services for {selectArea.name}?</h3>
                                 <p>Yes you are correct, all of our packages are based on a <strong>PER CALL BILLING</strong> instead of per minute, and we believe that you should not pay more if your clients request information that require detailed responses. We are an extremely economical resource to provide you with the necessary answering service solutions, at a very competitive rate. Our basic telephone answering service is based on providing this necessary service at a rate within the reach of each business based on call volume.</p>
                            </article>
                            <article className="">
                                <ul className="feature-list">
                                <li>All calls answered in your company’s name</li>
                                <li>All messages logged and emailed / Text</li>
                                <li>Call Patch / Transfer*</li>
                                <li>Online access to all messages</li>
                                <li>After Hours Voicemail to email</li>
                                <li>General FAQ provided</li>
                                </ul>
                            </article>
                        </div>
                    </div>
                </div>
            </div>
            <div className="toll-free">
                <h1>Call Toll Free +1-888-846-7655</h1>
            </div>
            <div className="call-to-action">
                <h4>Ready to become Virtualize? Try Virtual Enterprise today
</h4>
                <p>And see why people around the world choose Virtual Enterprise as their telecommunication platform</p>
                <Link className="signup-link" to={''}>Sign Up</Link>
            </div>
            <Footer/>
        </React.Fragment>
    }
}




export default Details;